import { Injectable } from "@angular/core";
import { BaseService } from "./default/base.service";
import { HttpClient } from "@angular/common/http";
import { take } from "rxjs/operators";
import { Store } from "@ngrx/store";
import {
  saveAcceptTermsOfuse,
  saveAllState,
  saveCanBid,
} from "src/app/store/auction.actions";
import { AuthService } from "./default/auth.service";

@Injectable({
  providedIn: "root",
})
export class CorePermissionService extends BaseService {
  constructor(
    private httpClient: HttpClient,
    private store: Store<{ stateAction: any }>,
    private authService: AuthService
  ) {
    super(httpClient);
  }

  getInfoUserPermission(id) {
    this.http
      .get(`${this.urlApi}/auction/info?auctionId=${id}`)
      .pipe(take(1))
      .subscribe((result: any) => {
        const permissionCard = this.verifyPermissionCard(
          result.canBid,
          result.acceptTermsOfuse
        );
        this.store.dispatch(saveAllState({ ...result, permissionCard }));
      });
  }

  getCanBid() {
    this.httpClient
      .get(`${this.urlApi}/user/can-bid`)
      .pipe(take(1))
      .subscribe((result: any) => {
        this.store.dispatch(
          saveCanBid({
            canBid: result.canBid,
          })
        );
      });
  }

  verifyPermissionCard(canBid, acceptTermsOfuse) {
    const isLogado = this.authService.isTokenValid();
    if (isLogado && !canBid) {
      return "restricted";
    }

    if (isLogado && !acceptTermsOfuse) {
      return "notTermsOfuse";
    }
    return "standard";
  }

  // Se usuário não esta logado
  //   - direcionar para /login

  // Se usuário logado e não aceitou o termo
  //   - Apresentar botão "Quero participar"

  // Se usuário logado e com restrição
  //   - Apresentar card de inadimplência.
}
